<div class="row pay-method-container d-block">
  <div class="col-12 px-0 px-sm-3 d-flex flex-column">
    <div class="row d-block card-pay-method-container" *ngIf="getCardPayMethod() as cardPayMethod">
      <div class="col-12 pay-method-panel f-roboto">
        <app-payment-method [paymentProvider]="paymentProviderIdentifier" [paymentType]="paymentMethod.TYPE_CARD"
                            [paymentMethod]="cardPayMethod"
                            [selected]="selectedPayMethodTypeCustom === paymentMethod.TYPE_CARD"
                            [paymentImgUrl]="cardPayMethod.imageUrl">
          <div class="panel-body mt-3" *ngIf="selectedPayMethodTypeCustom === paymentMethod.TYPE_CARD">
            <div class="card-container d-flex flex-column gap-1">
              <ng-container *ngFor="let payMethod of cardMethodCollection">
                <div class="card active" [ngClass]="{ 'card-selected': selectedCardMethod === payMethod }"
                     (click)="onClickedCardMethod(payMethod)">
                  <img [src]="payMethod.imageUrl" />
                  <p>{{ payMethod.cardBrand }}</p>
                  <p>{{ payMethod.cardMask }}</p>
                  <p>{{ payMethod.cardExpirationMonth }}/{{ payMethod.cardExpirationYear }}</p>
                </div>
              </ng-container>
            </div>

            <div class="card-form mt-3" [class.hidden]="selectedCardMethod">
              <div class="row flex-column d-block">
                <div class="col">
                  <div [id]="secureFormNumberContainerId" class="form-control p-0"></div>
                </div>
                <div class="col mt-2">
                  <div class="row">
                    <div class="col-7">
                      <div [id]="secureFormDateContainerId" class="form-control p-0"></div>
                    </div>
                    <div class="col-5">
                      <div [id]="secureFormCvvContainerId" class="form-control p-0"></div>
                    </div>
                  </div>
                </div>
                <div class="col" *ngIf="payuCardErrorMessages.length > 0">
                  <div *ngFor="let error of payuCardErrorMessages" class="invalid-feedback d-inline-block">
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </app-payment-method>
      </div>
    </div>
    <div class="row d-block blick-pay-method-container" *ngIf="getBLIKPayMethod() as blikPayMethod">
      <div class="col-12 pay-method-panel f-roboto">
        <app-payment-method [paymentMethod]="blikPayMethod" [paymentType]="paymentMethod.TYPE_BLIK"
                            [paymentProvider]="paymentProviderIdentifier"
                            [selected]="selectedPayMethodTypeCustom === paymentMethod.TYPE_BLIK"
                            [paymentImgUrl]="blikPayMethod.imageUrl">
          <div class="panel-body" *ngIf="selectedPayMethodTypeCustom === paymentMethod.TYPE_BLIK">
            <div class="t6-container">
              <div class="form-group mb-0 required row d-block mt-4" [formGroup]="form">
                <div class="col-6 ms-3">
                  <input type="text" class="form-control" id="blik_t6" data-charset="_X_ X_X" placeholder="___ ___"
                         formControlName="blikCode" [placeholder]="'payment.provider.payu.blik-code' | translate"
                         matInput mask="000000" />
                  <ng-container *ngIf="(form.touched && form.dirty) || formSubmitAttempt">
                    <span *ngIf="!form.get('blikCode').valid && !form.get('blikCode')?.errors?.minLength === true"
                          class="invalid-feedback d-inline-block">{{
                      'payment.provider.payu.blik-valid-info' | translate
                    }}</span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </app-payment-method>
      </div>
    </div>
    <div class="row d-block link-pay-method-container"
         *ngIf="payByLinkMethodCollection && payByLinkMethodCollection.length > 0">
      <div class="col-12 pay-method-panel f-roboto">
        <app-payment-method [paymentType]="paymentMethod.TYPE_PBL" [paymentProvider]="paymentProviderIdentifier"
                            [paymentImgUrl]="getDefaultPaymentImageUrl"
                            [selected]="selectedPayMethodTypeCustom === paymentMethod.TYPE_PBL">
          <div class="panel-body" *ngIf="selectedPayMethodTypeCustom === paymentMethod.TYPE_PBL">
            <div class="pay-by-link-container mt-4">
              <div class="pay-by-link" [ngClass]="{ selected: selectedPayByLinkMethod === payMethod }"
                   *ngFor="let payMethod of payByLinkMethodCollection" (click)="onClickedPayByLinkMethod(payMethod)">
                <img [src]="payMethod.imageUrl" />
              </div>
            </div>
          </div>
        </app-payment-method>
      </div>
    </div>
    <div class="row d-block google-pay-method-container" *ngIf="getGooglePayPayMethod() as googlePayMethod">
      <div class="col-12 pay-method-panel f-roboto">
        <app-payment-method [paymentMethod]="googlePayMethod" [paymentType]="paymentMethod.TYPE_GPAY"
                            [paymentProvider]="paymentProviderIdentifier"
                            [selected]="selectedPayMethodTypeCustom === paymentMethod.TYPE_GPAY"
                            [paymentImgUrl]="googlePayMethod.imageUrl">
          <div class="panel-body" *ngIf="selectedPayMethodTypeCustom === paymentMethod.TYPE_GPAY">
            <div class="t6-container"></div>
          </div>
        </app-payment-method>
      </div>
    </div>
    <div class="row d-block apple-pay-method-container" *ngIf="getApplePayPayMethod() as applePayMethod">
      <div class="col-12 pay-method-panel f-roboto">
        <app-payment-method [paymentMethod]="applePayMethod" [paymentProvider]="paymentProviderIdentifier"
                            [selected]="selectedPayMethodTypeCustom === paymentMethod.TYPE_APAY"
                            [paymentType]="paymentMethod.TYPE_APAY" [paymentImgUrl]="applePayMethod.imageUrl">
          <div class="panel-body" *ngIf="selectedPayMethodTypeCustom === paymentMethod.TYPE_APAY">
            <div class="t6-container"></div>
          </div>
        </app-payment-method>
      </div>
    </div>
  </div>
</div>